import { IProfile } from '@assess/shared/data-mart';

import { offsetMaxDate, offsetMinDate } from './shared-dos-min-max.function';
import { ISupplementalEvidenceOption } from '../entity/program-period-config/quality-section/supplemental-evidence-option.interface';
import { DateOfServiceRequirementOverride } from '../enum/dos-requirement-override.enum';
import { IDateOfServiceMinMax } from '../types/date-min-max.type';

export function supplementalEvidenceDosMinMax(
  profile?: IProfile,
  option?: ISupplementalEvidenceOption,
  isGracePeriod?: boolean
): IDateOfServiceMinMax {
  const birthDate = profile?.birthDate ? new Date(profile?.birthDate) : undefined;
  const configMin = option?.dateOfServiceMin ? new Date(option.dateOfServiceMin) : undefined;
  const configMax = option?.dateOfServiceMax ? new Date(option.dateOfServiceMax) : undefined;
  const today = new Date();

  const isExplicitlyRequired = option?.dateOfServiceRequirementOverride === DateOfServiceRequirementOverride.Required;
  const shouldApplyMinDefault = configMin || isExplicitlyRequired;

  const minDate = configMin ?? (shouldApplyMinDefault ? birthDate : undefined);
  const maxDate = configMax && configMax < today ? configMax : today;

  const min = minDate ? offsetMinDate(minDate, isGracePeriod) : undefined;
  const max = maxDate ? offsetMaxDate(maxDate, isGracePeriod) : undefined;

  return { min, max } as IDateOfServiceMinMax;
}
